// Keep the legacy IDs used by accounting; document kind is a separate field.
export function changeIntrareDocument(prev, tip_document) {
  const id = { Aviz: 2, Borderou: 8, Proforma: 1 }[tip_document] || 1;
  return {
    ...prev, tip_document, tip_factura: id,
    tip_factura_label: id === 1 ? "Normală" : tip_document,
  };
}

export function changeIesireDocument(prev, tip_document) {
  return {
    ...prev, tip_document,
    tip_factura_iesire_id: tip_document === "Factura" ? 1 : null,
    tip_factura_iesire_label: tip_document === "Factura" ? "Normală" : "",
  };
}

export function intrareClassificationLabel(id, label) {
  return Number(id) === 1 ? "Normală" : label || "";
}
